<template>
  <div id="contents" class="myShopping contents">
    <div class="myInfo">
      <div class="myInfoLogin" v-if="isLogin">
        <span class="myNickname">{{ maskedLoginId }}</span>
        <span class="myEmail">{{ nexonName }}</span>
        <button type="button" class="btLogout" @click="handleLogout">
          로그아웃
          <span class="icon iconLogout"></span>
        </button>
        <div v-if="isInpayPayment" class="game_info">
          <div class="game_name_box">
            <span class="game_text">{{ gameName }}</span>
          </div>
          <div class="character_info">
            <div v-if="existSelectedCharacter">
              <span class="character_text">{{ selectedCharacter.gcName }}</span>
              <div>
                <span class="region_text">
                  {{ selectedCharacter.worldName }}
                </span>
                <span class="bar"></span>
                <span class="region_text">{{ selectedCharacter.gcLevel }}</span>
                <span class="bar"></span>
                <span class="region_text">{{ selectedCharacter.gcClass }}</span>
              </div>
            </div>
            <div v-else class="no_character_text">
              설정된 캐릭터가 없습니다.
            </div>
            <button
              type="button"
              class="character_change_button"
              @click.prevent="handleClick('/characters', 'CharacterSetting')"
            >
              <span class="character_change_button_text">
                {{ existSelectedCharacter ? '캐릭터 변경' : '캐릭터 설정' }}
              </span>
            </button>
          </div>
        </div>
      </div>
      <a class="myInfoLogout" href="" @click.prevent="handleLogin" v-else>
        로그인해주세요.
      </a>
      <div v-if="isLogin && isGameCoinPayment" class="myInfoPoint">
        <span class="pointName">{{ balance.currencyName }}</span>
        <span class="myPoint">
          <b>{{ balance.total.addComma() }}</b>
          {{ balance.currencyUnit }}
        </span>
      </div>
      <div v-if="!isInpayPayment" class="myInfoProducts">
        <a href="" @click.prevent="handleClick('/coupon', 'CouponList')">
          <span class="icon iconCoupon"></span>
          <span>
            내 쿠폰함
            <strong v-if="isLogin">{{ couponCount }}</strong>
          </span>
        </a>
        <a
          v-if="enableCart"
          href=""
          @click.prevent="handleClick('/cart', 'Cart')"
        >
          <span class="icon iconCart"></span>
          <span>
            장바구니
            <strong v-if="isLogin">{{ cartUniqueQuantity }}</strong>
          </span>
        </a>
      </div>
      <div
        class="myInfoPurchase"
        :style="{ marginTop: isInpayPayment ? '10px' : '' }"
      >
        <a @click.prevent="handleClick('/purchase', 'OrderList')">
          <span class="text">구매내역</span>
          <span class="icon iconMore2"></span>
        </a>
        <a
          v-if="!isInpayPayment"
          @click.prevent="handleClick('/cancel', 'RefundList')"
        >
          <span class="text">청약철회 내역</span>
          <span class="icon iconMore2"></span>
        </a>
        <a
          v-if="enableReward && !isInpayPayment"
          @click.prevent="handleClick('/reward')"
        >
          <span class="text">리워드 프로그램</span>
          <span class="icon iconMore2"></span>
        </a>
      </div>
    </div>
    <products-list-simple
      :products="recentList"
      :to="'/recent'"
      listTitle="최근 본 상품"
    ></products-list-simple>
    <div class="myInfoBt">
      <a :href="customerCenter" target="_blank">
        <span class="icon iconCustomer"></span>
        고객센터
      </a>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import {
  isLogin,
  logout,
  goToLoginPage,
  beforeSendLog,
  isMobile
} from '@/utils'
import ProductsListSimple from '@/views/shop/ProductsListSimple'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MyShopping',
  components: {
    ProductsListSimple
  },
  data() {
    return {
      isLogin: isLogin()
    }
  },
  computed: {
    ...mapGetters('main', [
      'enableReward',
      'enableCart',
      'paymentSystemType',
      'name',
      'gameName'
    ]),
    ...mapGetters('cart', ['cartUniqueQuantity']),
    ...mapGetters('my', ['loginID', 'nexonName', 'couponCount', 'balance']),
    ...mapGetters('recent', ['recentList']),
    ...mapGetters('character', ['selectedCharacter']),
    customerCenter() {
      return isMobile
        ? 'https://support.nexon.com/mobile/reception?type=0'
        : 'http://help.nexon.com'
    },
    isGameCoinPayment() {
      return this.paymentSystemType === 2
    },
    isInpayPayment() {
      return this.paymentSystemType === 3
    },
    existSelectedCharacter() {
      return !Object.values(this.selectedCharacter).every(
        value => value === null || value === 0
      )
    },
    maskedLoginId() {
      const loginId = this.loginID

      if (!loginId) {
        return ''
      }
      if (loginId.indexOf('@') === -1) {
        if (this.checkIfTPAAccount(loginId)) {
          return loginId.split('(')[0]
        }
        return this.maskStringHalf(loginId)
      }

      const splitIds = loginId.split('@')
      const maskedId = this.maskStringHalf(splitIds[0])

      return `${maskedId}@${splitIds[1]}`
    }
  },
  methods: {
    ...mapActions('my', ['getUserData']),
    ...mapActions('recent', ['getRecentProductList']),
    ...mapActions('character', ['getSelectedCharacter']),
    handleLogin() {
      goToLoginPage()
    },
    handleLogout() {
      beforeSendLog('LogOut_top')

      if (window.inface) {
        window.inface.auth.gotoSignOut()
      }

      this.isLogin = false
    },
    maskStringHalf(str) {
      if (!str) {
        return ''
      }

      return `${str.slice(0, Math.floor(str.length / 2))}${'*'.repeat(
        str.length - Math.floor(str.length / 2)
      )}`
    },
    checkIfTPAAccount(loginId) {
      if (
        loginId.indexOf('네이버 계정') ||
        loginId.indexOf('구글 계정') ||
        loginId.indexOf('페이스북 계정')
      ) {
        return true
      }

      return false
    },
    handleClick(to, object) {
      if (object) beforeSendLog(object)
      this.$router.push(to)
    }
  },
  mounted() {
    EventBus.$on('logout', () => {
      this.isLogin = false
    })
    if (this.isLogin) {
      this.getUserData()
      this.getRecentProductList()
      if (this.isInpayPayment) {
        this.getSelectedCharacter()
      }
    } else {
      goToLoginPage()
    }
  }
}
</script>
<style lang="scss">
.myInfoLogin,
.myInfoLogout {
  padding: 20px 16px;
  color: #fff;
  background-color: #6134f1;
  font-size: 17px;
  .myNickname {
    display: block;
  }
  .myEmail {
    display: block;
    padding-top: 9px;
    font-size: 13px;
    opacity: 0.8;
  }
}
.myInfoLogin {
  position: relative;
  padding-top: 20px;
}
.myInfoLogout {
  display: block;
  padding: 32px 16px;
}
.btLogout {
  position: absolute;
  top: 34px;
  right: 5px;
  padding: 10px;
  font-size: 12px;
  color: #c9c2e0;
  .icon {
    margin: 0 0 3px 4px;
  }
}
.myInfoPoint,
.myInfoProducts,
.myInfoPurchase,
.myInfoBt {
  margin-bottom: 10px;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
}
.myInfoPoint {
  height: 49px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0 16px;
  .pointName {
    flex: 1;
    font-size: 13px;
  }
  .myPoint {
    text-align: right;
    font-size: 15px;
    color: #6134f1;
    b {
      margin-right: 5px;
    }
  }
}
.myInfoProducts {
  display: flex;
  position: relative;
  height: 89px;
  font-size: 13px;
  a {
    flex: 1;
    height: 88px;
    padding-top: 21px;
    text-align: center;
  }
  .iconCoupon {
    margin: 1px auto 7px;
  }
  .iconCart {
    margin: 1px auto 6px;
    &::before {
      content: '';
      position: absolute;
      top: 21px;
      left: 50%;
      display: block;
      width: 1px;
      height: 46px;
      background-color: #a6a8b3;
    }
  }
  span:not(.icon) {
    display: block;
  }
  strong {
    font-weight: bold;
    color: #6134f1;
  }
}
.myInfoPurchase {
  a {
    display: block;
    width: 100%;
    height: 46px;
    padding: 15px 16px 0;
    font-size: 14px;
    text-align: center;
    border-bottom: 1px solid #efefef;
    cursor: pointer;
    &:last-child {
      height: 45px;
      border-bottom-width: 0;
    }
    span:first-child {
      display: inline-block;
      width: 100%;
      padding-top: 2px;
      text-align: left;
    }
    .icon {
      margin: 0 0 3px -8px;
    }
  }
}
.myShopping .productsListSimple {
  margin-bottom: 10px;
}
.myInfoBt {
  margin-bottom: 0;
  a {
    display: block;
    width: 100%;
    height: 45px;
    padding: 15px 16px 0;
    font-size: 14px;
    text-align: left;
    color: #151721;
    .icon {
      margin: 0 2px 3px 0;
    }
  }
}
.game_info {
  display: flex;
  flex-direction: column;
  padding: 13px 12px 12px 16px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 14px 0 0;
  border-radius: 4px;
  border: solid 1px rgba(255, 255, 255, 0.1);
  font-family: 'Noto Sans KR';
  .game_text {
    font-size: 13px;
  }
  .character_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
    .character_text {
      font-size: 15px;
      font-weight: bold;
    }
    .region_text {
      opacity: 0.8;
      font-size: 13px;
    }
    .bar {
      display: inline-block;
      width: 1px;
      height: 12px;
      margin: 0 6px 0 6px;
      background-color: #a5a5ac;
    }
    .character_change_button {
      padding: 0px 12px 2px 12px;
      border-radius: 13px;
      background-color: rgba(255, 255, 255, 0.2);
      cursor: pointer;
    }
    .character_change_button_text {
      height: 16px;
      font-size: 11px;
      color: #fff;
    }
    .no_character_text {
      opacity: 0.8;
      font-size: 15px;
    }
  }
}
</style>
